var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChallenge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-48 -48 560 560",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "real-path",
    d: "M426.67,161.188c13.874-1.972,27.251-8.292,37.924-18.965c26.182-26.182,26.183-68.633,0.001-94.815 c-26.185-26.182-68.633-26.182-94.815,0.001c-10.672,10.672-16.992,24.051-18.964,37.924L265.483,0l-94.814,94.815 c13.877,1.972,27.252,8.292,37.924,18.964c26.183,26.182,26.183,68.634,0,94.816c-26.183,26.181-68.632,26.181-94.814-0.001 c-10.673-10.672-16.993-24.05-18.965-37.925L0.002,265.481l85.335,85.335c-13.877,1.972-27.253,8.292-37.927,18.964 c-26.181,26.182-26.182,68.633,0,94.814c26.183,26.182,68.633,26.182,94.815,0.001c10.672-10.673,16.993-24.05,18.964-37.924 l85.331,85.331l94.814-94.814c-13.877-1.971-27.251-8.291-37.925-18.964c-26.183-26.183-26.183-68.632,0-94.815 c26.183-26.181,68.632-26.183,94.814,0c10.675,10.675,16.992,24.05,18.964,37.924l94.814-94.814L426.67,161.188z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChallenge);
export default __webpack_public_path__ + "static/media/icon-challenge.1dbaa1b01b35cd7f6dc98bf2f686302b.svg";
export { ForwardRef as ReactComponent };